// import external dependencies
import 'jquery';
// Import everything from autoload
import "./autoload/_bootstrap.js"; import "./autoload/functions-comunes.js"; import "./autoload/functions-initlisteners.js"; import "./autoload/plugins"; import "./autoload/plugins/chosen"; import "./autoload/plugins/chosen/index.js"; import "./autoload/plugins/index.js"

// FontAwesome 5 PRO
// import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import { fab  } from "@fortawesome/free-brands-svg-icons";
// import { fas } from '@fortawesome/free-solid-svg-icons'
// import { fal } from '@fortawesome/pro-light-svg-icons'
// library.add(fab,fas,fal);
// dom.watch();
//end FontAwesome

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import busqueda from './routes/busqueda';



/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  busqueda
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js